import React from "react";
import CTASection from "../CTASection/CTASection";
import styles from "./AuthorisedChannelPartner.module.css";
import channelPartnerBg from "../../../../images/hero.jpg";

export default function AuthorisedChannelPartner() {
  return (
    <section className={styles.section} id="channel-partner">
      <div className={styles.imageArea}>
        <img
          className={styles.bgImage}
          src={channelPartnerBg}
          alt="Electrical control panels"
          loading="lazy"
        />
        <div className={styles.overlay} aria-hidden="true" />
        <div className={styles.content}>
          <div className={styles.inner}>
            <span className={styles.eyebrow}>Authorised Channel Partner</span>
            <h2 className={styles.title}>Authorised Channel Partner</h2>
            <p className={styles.description}>
              Mitsubishi Electric FA Authorised Channel Partner India
            </p>
          </div>
        </div>
      </div>
      <CTASection
        title="Learn more about Authorised Channel Partner"
        description="Controllers, Circuit Breakers, PM Meters, Contactors and Motor Starters."
        label="Know More..."
        subLabel="about ACP"
        href="/channel-partner"
      />
    </section>
  );
}
